// extracted by mini-css-extract-plugin
export default {"ButtonSection":"GridFrotas_ButtonSection__hpckM","UlCuston":"GridFrotas_UlCuston__O7rXD"};